import * as React from 'react';
import { Suggestion } from '../suggestion';
import { config } from '../../../../config';
import { Path } from '../../../..';
import { composer } from '../../../../component-decorators/composer';
import s from './categories-suggestions.scss';
import { Text } from 'wix-style-react';
import { SuggestionType } from '../../../../types/common/marketplace';
export var CategoriesSuggestions = composer()
    .withTranslation()
    .withBiLogger()
    .compose(function (_a) {
    var categories = _a.categories, t = _a.t, searchValue = _a.searchValue, addSelectedNode = _a.addSelectedNode, onSearchValueChange = _a.onSearchValueChange, sendSearchSearchClickBi = _a.sendSearchSearchClickBi;
    var removeSpaces = function (str) { return str && str.replace(/\s/g, ''); };
    return (React.createElement(React.Fragment, null,
        categories.length > 0 && (React.createElement("div", { className: s.categoriesSuggestionsTitle, "data-testid": "categories-suggestions-title" },
            React.createElement("div", { className: s.titleText },
                React.createElement(Text, { size: 'small' }, t('search.box.categories.title'))))),
        categories.map(function (category) { return (React.createElement(Suggestion, { key: removeSpaces(category.slug), suggestionKey: removeSpaces(category.slug), value: category.name, suggestionType: SuggestionType.CATEGORY, onClick: function () {
                onSearchValueChange(category.name);
                sendSearchSearchClickBi(searchValue, 'categories', category.index);
                config.goto({ path: Path.CATEGORY, slug: category.slug });
            }, icon: category.svg, selected: category.selected, index: category.index, addSelected: addSelectedNode })); })));
});
//# sourceMappingURL=categories-suggestions.js.map